import styled from 'styled-components';
import { background, border, color, flexbox, grid, layout, position, shadow, space, typography } from 'styled-system';
import sx from '../../utils/sx';
const BoxPropsNotToRendered = ['display', 'alignItems', 'flex', 'position', 'flexDirection', 'width', 'height', 'mt', 'color'];
const Box = styled.div.withConfig({
  shouldForwardProp: prop => !BoxPropsNotToRendered.includes(prop)
})(space, color, typography, layout, flexbox, grid, background, border, position, shadow, sx);
export default Box;